// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { ENDPOINTS } from './endpoints-url';

export const environment = {
  production: false,
  baseHrefPrestadores: 'http://192.168.1.32:8035/',
  baseHref: 'https://api-homologacao.memory.com.br/api/siap-api-processamento-notas-iss-homolog/',
  gerarToken: 'https://login-demonstracao.memory.com.br/gerartoken',
  validarToken: `https://login-demonstracao.memory.com.br/validartoken`,
  dadosEntidadeURL: 'https://api-homologacao.memory.com.br/api/siap-api-contabilidade-homolog/recuperarCabecalhoPadrao',
  dadosEntidadeURLTenantId: 'https://api-homologacao.memory.com.br/api/siap-api-contabilidade-homolog/recuperarcabecalho',
  urls: ENDPOINTS
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
